<template>
  <nav id="header" class="navbar navbar-expand-md navbar-dark bg-dark shadow-sm">
    <div class="container-lg px-lg-0">
      <a class="navbar-brand" href="https://lupiteam.net/">
        <img alt="Logo LupiTeam" title="Logo LupiTeam" class="logo" src="./assets/logo.png"> LupiTeam
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <!-- Left Side Of Navbar -->
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link">
              <span aria-hidden="true" title="Downloads" class="fas fa-download fa-fw"></span> Downloads
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://lupiteam.net/">
              <span aria-hidden="true" title="Reader" class="fas fa-book-open fa-fw"></span> Reader
            </a>
          </li>
        </ul>

        <!-- Right Side Of Navbar -->
        <ul class="navbar-nav">
          <li class="nav-item" style="width: 100%">
            <input id="nav-filter" class="form-control mr-sm-2 card-search" type="search" placeholder="Filtra"
                    aria-label="Filter" name="filter" autocomplete="off">
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <main class="container-lg">
    <router-view/>
  </main>
  <footer>
    <div class="footer-copyright text-center py-3 text-muted">
      Se ti piacciono i manga che leggi qui, considera di comprare le versioni cartacee appena disponibili in Italia.
Tutti i diritti delle immagini appartengono ai rispettivi proprietari. Gruppo no profit, non guadagniamo un centesimo da ciò che facciamo.
    </div>
  </footer>
</template>

<style>
body {
  font-family: Nunito,sans-serif;
  font-size: .9rem;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

main {
  min-height: calc(100vh - 140px);
}

body.dark {
  --white-10: #ffffff;
  --white-6: #cfd2d6;
  --white-5: #c4c8cc;
  --black-0: #1e1e1e;
  --black-1: #2d2d2d;
  --black-2: #303030;
  --black-3: #393939;
  --black-6: #404345;
  --red-0: #572f32;
  --blue-0: #2b3c5a;
  --bkg: var(--black-1);
  background: var(--bkg);
  color: #c4c8cc;
}

body.dark {
  background: var(--bkg);
  color: var(--white-5);
}

.logo {
  width: auto;
  height: 40px;
  margin-top: -4px;
  margin-right: 5px;
}

body.dark .bg-dark {
background-color: var(--black-3) !important;
}

body.dark .navbar-dark .navbar-brand {
  color: var(--white-10);
}

body.dark .navbar-dark .navbar-nav .nav-link {
  color: var(--white-5);
}

body.dark a:hover,
body.dark .navbar-dark .navbar-nav .nav-link:hover,
body.dark .navbar-dark .navbar-nav .nav-link.router-link-exact-active,
body.dark .item.licensed .chapter .filter:hover {
  color: var(--white-10);
}

.footer-copyright {
  max-width: 1140px;
  padding: 8px;
  margin: auto;
}

body.dark a:not(.btn),
body.dark .close {
  color: var(--white-6);
  background-color: transparent;
  text-decoration: none;
}

body.dark .bg-white, body.dark .breadcrumb {
  background-color: var(--black-3) !important;
}

body.dark .breadcrumb-item.active {
  color: var(--white-10);
}

body.dark .navbar-light .navbar-brand {
  color: var(--white-10);
}

body.dark .navbar-light .navbar-nav .nav-link {
  color: var(--white-5);
}

body.dark a:hover,
body.dark .navbar-light .navbar-nav .nav-link:hover,
body.dark .navbar-light .navbar-nav .nav-link.router-link-exact-active,
body.dark .item.licensed .chapter .filter:hover {
  color: var(--white-10);
}

body.dark .item.hidden {
  background-color: var(--red-0);
}

body.dark .item.licensed {
  background-color: var(--blue-0);
}

body.dark .item.read:not(.hidden, .licensed) {
  background-color: var(--black-2);
}

body.dark .form-control, body.dark .custom-file-label {
  background-color: var(--bkg) !important;
  color: var(--white-6);
}

body.dark .custom-file-label::after {
  background-color: var(--black-0) !important;
  color: var(--white-6);
}

body.dark #results-box, body.dark #results-box a {
  background-color: var(--black-6);
  color: var(--white-6);
}

body.dark .dropdown-menu {
  background-color: var(--black-3);
}

body.dark .custom-select {
  background-color: var(--black-3);
  color: var(--white-6);
  background: var(--black-3) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23cfd2d6' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
}

body.dark .dropdown-item:hover {
  background-color: var(--black-6);
}

body.dark .card-header {
  background-color: var(--black-6);
}

body.dark .card {
  background-color: var(--black-3);
}

body.dark .ratings .star {
  color: var(--black-0);
}

body.dark .ratings .star:hover,
body.dark .ratings .star.selected,
body.dark .ratings .star:hover ~ .star,
body.dark .ratings .star.selected ~ .star {
  color: var(--white-6);
}

body.dark .table, body.dark .table-hover tbody tr:hover {
  color: var(--white-5);
}

body.dark .modal-content {
  background-color: var(--black-3);
}

body.dark .navbar-light .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E")
}

.item {
  border-bottom: var(--black-6) 1px solid;
  min-height: 130px;
}

.banner {
  height: 154px;
  width: 100%;
}
</style>
